!function(window) {
var baselayers = {
	"OpenStreetMap": L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
	})
};

String.prototype.stripSlashes = function(){
	return this.replace(/\\(.)/mg, "$1");
}

var drawnItems;
var overlays = {};
var lng = 'sl';
var r1;
var r2;
var geoLayers = [];
var layerGroup;
var externalGroup;
var geoserverGroup;
var debug = false;

let allLayers = [];
let onClickPopupFunctions = [];

function template(str, data) {
	return str.replace(/\{ *([\p{L}\w_ -]+) *\}/gu, function (str, key) {
		debugOut(key);
		var value = data[key];

		if (value === undefined) {
			throw new Error('No value provided for variable ' + str);

		} else if (typeof value === 'function') {
			value = value(data);
		}
		return value;
	});
}

var _round = function(num, len) {
	return Math.round(num*(Math.pow(10, len)))/(Math.pow(10, len));
};
var strLatLng = function(latlng) {
	return "("+_round(latlng.lat, 6)+", "+_round(latlng.lng, 6)+")";
};
var langSettings = {
	'sl': {
		'area': 'Površina',
		'radius': 'Radij',
		'distance': 'Dolžina'
	},
	'en': {
		'area': 'Area',
		'radius': 'Radius',
		'distance': 'Distance'
	}
}
var drawLang = {
	'sl': {
		draw: {
			toolbar: {
				// #TODO: this should be reorganized where actions are nested in actions
				// ex: actions.undo or actions.cancel
				actions: {
					title: 'Prekliči risanje',
					text: 'Prekliči'
				},
				finish: {
					title: 'Končaj risanje',
					text: 'Končaj'
				},
				undo: {
					title: 'Izbriši zadnjo narisano točko',
					text: 'Izbriši zadnjo točko'
				},
				buttons: {
					polyline: 'Nariši polilinijo',
					polygon: 'Nariši poligon',
					rectangle: 'Nariši pravokotnik',
					circle: 'Nariši krog',
					marker: 'Dodaj točko',
					circlemarker: 'Dodaj krogec'
				}
			},
			handlers: {
				circle: {
					tooltip: {
						start: 'Kliknite in povlecite za dodajanje.'
					},
					radius: 'Radij'
				},
				circlemarker: {
					tooltip: {
						start: 'Kliknite na zemljevid za dodajanje.'
					}
				},
				marker: {
					tooltip: {
						start: 'Kliknite na zemljevid za dodajanje.'
					}
				},
				polygon: {
					tooltip: {
						start: 'Kliknite za začetek risanja.',
						cont: 'Kliknite za dodajanje naslednje točke.',
						end: 'Kliknite začetno točko za zaključek.'
					}
				},
				polyline: {
					error: '<strong>Napaka:</strong> črte se križajo!',
					tooltip: {
						start: 'Kliknite za risanje črt.',
						cont: 'Kliknite za naslednjo točko črte.',
						end: 'Kliknite zadnjo točko za končanje.'
					}
				},
				rectangle: {
					tooltip: {
						start: 'Kliknite in povlecite za dodajanje pravokotnika.'
					}
				},
				simpleshape: {
					tooltip: {
						end: 'Sprostite miško za končanje.'
					}
				}
			}
		},
		edit: {
			toolbar: {
				actions: {
					save: {
						title: 'Shrani spremembe',
						text: 'Shrani'
					},
					cancel: {
						title: 'Prekliči urejanje, zavrži vse spremembe.',
						text: 'Prekliči'
					},
					clearAll: {
						title: 'Odstrani vse plasti',
						text: 'Odstrani vse'
					}
				},
				buttons: {
					edit: 'Uredi plasti',
					editDisabled: 'Plasti ne obstajajo',
					remove: 'Odstrani plasti',
					removeDisabled: 'Plasti ne obstajajo'
				}
			},
			handlers: {
				edit: {
					tooltip: {
						text: 'Premaknite točke za spremembo.',
						subtext: 'Kliknite prekliči za razveljavitev sprememb.'
					}
				},
				remove: {
					tooltip: {
						text: 'Kliknite na sloj za odstranitev.'
					}
				}
			}
		}
	},
	'en': {
		draw: {
			toolbar: {
				// #TODO: this should be reorganized where actions are nested in actions
				// ex: actions.undo or actions.cancel
				actions: {
					title: 'Cancel drawing',
					text: 'Cancel'
				},
				finish: {
					title: 'Finish drawing',
					text: 'Finish'
				},
				undo: {
					title: 'Delete last point drawn',
					text: 'Delete last point'
				},
				buttons: {
					polyline: 'Draw a polyline',
					polygon: 'Draw a polygon',
					rectangle: 'Draw a rectangle',
					circle: 'Draw a circle',
					marker: 'Draw a marker',
					circlemarker: 'Draw a circlemarker'
				}
			},
			handlers: {
				circle: {
					tooltip: {
						start: 'Click and drag to draw circle.'
					},
					radius: 'Radius'
				},
				circlemarker: {
					tooltip: {
						start: 'Click map to place circle marker.'
					}
				},
				marker: {
					tooltip: {
						start: 'Click map to place marker.'
					}
				},
				polygon: {
					tooltip: {
						start: 'Click to start drawing shape.',
						cont: 'Click to continue drawing shape.',
						end: 'Click first point to close this shape.'
					}
				},
				polyline: {
					error: '<strong>Error:</strong> shape edges cannot cross!',
					tooltip: {
						start: 'Click to start drawing line.',
						cont: 'Click to continue drawing line.',
						end: 'Click last point to finish line.'
					}
				},
				rectangle: {
					tooltip: {
						start: 'Click and drag to draw rectangle.'
					}
				},
				simpleshape: {
					tooltip: {
						end: 'Release mouse to finish drawing.'
					}
				}
			}
		},
		edit: {
			toolbar: {
				actions: {
					save: {
						title: 'Save changes',
						text: 'Save'
					},
					cancel: {
						title: 'Cancel editing, discards all changes',
						text: 'Cancel'
					},
					clearAll: {
						title: 'Clear all layers',
						text: 'Clear All'
					}
				},
				buttons: {
					edit: 'Edit layers',
					editDisabled: 'No layers to edit',
					remove: 'Delete layers',
					removeDisabled: 'No layers to delete'
				}
			},
			handlers: {
				edit: {
					tooltip: {
						text: 'Drag handles or markers to edit features.',
						subtext: 'Click cancel to undo changes.'
					}
				},
				remove: {
					tooltip: {
						text: 'Click on a feature to remove.'
					}
				}
			}
		}
	}
}

var debugOut = function(val){
	if(debug == true){
		console.log(val);
	}
}

function dragenter(evt) {
	evt.stopPropagation();
	evt.preventDefault();
	dropbox.style.background = 'green';
}

function dragover(evt) {
	evt.stopPropagation();
	evt.preventDefault();
	dropbox.style.background = 'green';
}
function drop(evt) {
	evt.stopPropagation();
	evt.preventDefault();
	handleFiles(evt);
	dropbox.style.background = 'white';
}

function selectFile(evt) {
	evt.stopPropagation();
	evt.preventDefault();
	handleFilesSelect(evt);
}

function getLanguageKey(key){
	return (typeof langSettings[lng][key] != 'undefined' && langSettings[lng][key] != '') ? langSettings[lng][key] : key;
}

function setLayerContent(layer, feature){
	var contentObject = feature.properties;
	if(feature.geometry.type == 'Polygon'){
		var latlngs = layer._defaultShape ? layer._defaultShape() : layer.getLatLngs(),
			area = L.GeometryUtil.geodesicArea(latlngs),
			distance = 0;
		if (latlngs.length >= 2) {
			for (var i = 0; i < latlngs.length-1; i++) {
				distance += latlngs[i].distanceTo(latlngs[i+1]);
			}
		}
		contentObject.area = L.GeometryUtil.readableArea(area, true);
		contentObject.distance = _round(distance, 2)+" m";
	} else if(feature.geometry.type == 'Circle'){
		var center = layer.getLatLng(),
					radius = layer.getRadius();
		contentObject.radius = _round(radius, 2)+'m';
		contentObject.area = L.GeometryUtil.readableArea(((Math.PI * radius * radius)*0.0001));
	} else if(feature.geometry.type == 'Polyline'){
		var latlngs = layer._defaultShape ? layer._defaultShape() : layer.getLatLngs(),
			distance = 0;
		if (latlngs.length > 2) {
			for (var i = 0; i < latlngs.length-1; i++) {
				distance += latlngs[i].distanceTo(latlngs[i+1]);
			}
			contentObject.distance = _round(distance, 2)+" m";
		}
	}
	var content = '';
	for (const key in contentObject) {
		if (Object.hasOwnProperty.call(contentObject, key)) {
			content += '<li><span class="key">'+getLanguageKey(key)+':</span><span class="values">'+contentObject[key]+'</span></li>';
		}
	}
	/*if(content){
		var displayContent = '<ul class="dataList">'+content+'</ul>';
		layer.bindPopup(displayContent);
		layer.on('click', function(el) {
			$('.layerData .data').html(displayContent);
			$('.layerData').removeClass('d-none');
		});
	}*/
}

function generatePopup(properties, template){
	var content = '';
	var displayContent = '';
	if(template != null){
		content = L.Util.template(
			template.replace(/\\(.)/mg, "$1"),
			properties
		);
	}else{
		Object.keys(properties).forEach(function(keyFeat) {
			content += '<li><span class="key">'+keyFeat+':</span><span class="values">'+properties[keyFeat]+'</span></li>';
		});
	}
	if(content){
		displayContent = '<ul class="dataList">'+content+'</ul>';
	}
	return displayContent;
}

function handleFilesSelect(evt) {
	const files = evt.target.files;
	lng = $('html').attr('lang');
	var output = [];
	var json;
	for (var i = 0, f; f = files[i]; i++) {
		var reader = new FileReader();
		reader.onload = (function (theFile) {
			return function (e) {
				try {
					json = JSON.parse(e.target.result);
					if(isJsonString(e.target.result)){
						new L.geoJSON(json, {
							onEachFeature: function (feature, layer) {
								setLayerContent(layer, feature)
							}
						}).addTo(map);
					} else {
						bootbox.alert('Napaka pri procesiranju GeoJSON datoteke');
					}
				} catch (ex) {
					bootbox.alert('Napaka pri procesiranju GeoJSON datoteke');
				}
			}
		})(f);
		reader.readAsText(f);
	}
}

function handleFiles(evt) {
	const dt = evt.dataTransfer;
	const files = dt.files;
	var output = [];
	var json;
	for (var i = 0, f; f = files[i]; i++) {
		var reader = new FileReader();
		reader.onload = (function (theFile) {
			return function (e) {
				try {
					json = JSON.parse(e.target.result);
					if(isJsonString(e.target.result)){
						new L.geoJSON(json, {
							onEachFeature: function (feature, layer) {
								setLayerContent(layer, feature)
							}
						}).addTo(map);
					} else {
						bootbox.alert('Napaka pri procesiranju GeoJSON datoteke');
					}
				} catch (ex) {
					bootbox.alert('Napaka pri procesiranju GeoJSON datoteke');
				}
			}
		})(f);
		reader.readAsText(f);
	}
}

function isJsonString(str) {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
}

var getPopupContent = function(layer) {
	if (layer instanceof L.Marker ) {
		return {'coordinates':strLatLng(layer.getLatLng())};
	} else if(layer instanceof L.CircleMarker) {
		var center = layer.getLatLng(),
					radius = layer.getRadius();
		return {'radius': _round(radius, 2)+'m', 'area': L.GeometryUtil.readableArea(((Math.PI * radius * radius)*0.0001))};
		
	} else if (layer instanceof L.Circle) {
		var center = layer.getLatLng(),
					radius = layer.getRadius();
		return {'radius': _round(radius, 2)+'m', 'area': L.GeometryUtil.readableArea(((Math.PI * radius * radius)*0.0001))};
	} else if (layer instanceof L.Polygon) {
		var latlngs = layer._defaultShape ? layer._defaultShape() : layer.getLatLngs(),
			area = L.GeometryUtil.geodesicArea(latlngs),
			distance = 0;
		if (latlngs.length >= 2) {
			for (var i = 0; i < latlngs.length-1; i++) {
				distance += latlngs[i].distanceTo(latlngs[i+1]);
			}
		}
		return {'area': L.GeometryUtil.readableArea(area, true), 'distance':+_round(distance, 2)+" m"};
	} else if (layer instanceof L.Polyline) {
		var latlngs = layer._defaultShape ? layer._defaultShape() : layer.getLatLngs(),
			distance = 0;
		if (latlngs.length < 2) {
			return {};
		} else {
			for (var i = 0; i < latlngs.length-1; i++) {
				distance += latlngs[i].distanceTo(latlngs[i+1]);
			}
			return {'distance':+_round(distance, 2)+" m"};
		}
	}
	return null;
};
function getRandomInt(min, max) {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min) + min);
}

const crs = new L.Proj.CRS('EPSG:3912',
	"+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs +type=crs", {
		origin: [368000, 243144],
		resolutions: [1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5],
		bounds: L.bounds([371516.81857077195, 30721.463201909326], [624198.9177847779, 194752.92903958913]),
});

function getURLData(loadedFrom){
	debugOut("START WMS MAP LOADING: "+loadedFrom);
	
	var layersArrays = getAllSelectedCheckboxes();
	params = new URLSearchParams(window.location.search);
	if(typeof externalGroup !== 'undefined'){
		externalGroup.clearLayers();
	}
	if(typeof geoserverGroup != 'undefined'){
		geoserverGroup.clearLayers();
	}
	$.post('/util/ajaxresponse.php', {'func':'external','external':params.get('layers')},function(data){
		allLayers = [];
		onClickPopupFunctions = [];
		$('.loader').remove();
		$('.totop-layer').css('display','none');
		$('.error-layer').css('display','none');
		
		if(data.length){
			var jsonData = JSON.parse(data);
			debugOut(jsonData);
			for (const [key, ext] of Object.entries(jsonData)) {
				const layerJsonData = jsonData[key];
				let layerObj = null;
				if(layerJsonData.layer_type == 'wms'){
					layerObj = handleWMSlayer(layerJsonData);
				} else if(layerJsonData.layer_type == 'wfs'){
					layerObj = handleWFSlayer(layerJsonData);
				} else {
					layerObj = handleOtherLayers(layerJsonData);
				}
				allLayers[layerJsonData.cs] = layerObj;
			}
		}
	});
	
	function handleWMSlayer(layerJsonData){
		$('[data-layer="'+layerJsonData.cs+'"]').html($('[data-layer="'+layerJsonData.cs+'"]').html()+'<span class="loader rm'+layerJsonData.cs+'"></span>');
		$('[data-settop="'+layerJsonData.cs+'"]').hide();
		
		//var crs = new L.Proj.CRS("EPSG:3912","+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=bessel +towgs84=409.545,72.164,486.872,-3.085957,-5.46911,11.020289,17.919665 +units=m +no_defs");
		
		var errorLayer = false;
		var mywms = null;
		if(layerJsonData.service_link.includes("zdravgozd")){ // exception for zdravgozd
			const link = layerJsonData.service_link;
			var randomColor = Math.floor(Math.random()*16777215).toString(16);
			mywms = L.esri.featureLayer({
				url: link,
				style: function () {
					return { color: "#"+randomColor+"", weight: 2 };
				}
			}).addTo(map);
			$('[data-layer="'+layerJsonData.cs+'"] .indicator').css({'background-color':'#'+randomColor,'border':'1px solid #333'});
			
		}else{
			mywms = L.tileLayer.wms(layerJsonData.service_link, {
				layers: layerJsonData.layers,
				format: 'image/png',
				transparent: true,
				opacity: layerJsonData.opacity,
				version: '1.3.0',
				//crs: crs,
				tiled: true,
			});
			mywms.on('tileerror', function(error, tile) {
				$('.rm'+layerJsonData.cs+'').remove();
				$('.error-layer[data-settop="'+layerJsonData.cs+'"]').css('display','block');
				$('.totop-layer[data-settop="'+layerJsonData.cs+'"]').css('display','none');
				errorLayer = true;
			});
		}
		
		onClickPopupFunctions.push([
			(e, wms) => onMapClick(e, wms),
			mywms,
			layerJsonData.cs
		]);
		
		function onMapClick(e, mywms) {
			var coord = e.latlng;
			var lat = coord.lat;
			var lng = coord.lng;
			var mapBounds = map.getBounds();
			var crsMap = map.options.crs;
			var nw = crs.project(mapBounds.getNorthWest());
			var ne = crs.project(mapBounds.getNorthEast());
			var sw = crs.project(mapBounds.getSouthWest());
			var se = crs.project(mapBounds.getSouthEast());
			var BBOX = L.bounds([nw, ne, sw, se]);
			
			BBOX = BBOX.min.x+','+BBOX.min.y+','+BBOX.max.x+','+BBOX.max.y;
			debugOut(BBOX);

			var WIDTH = map.getSize().x;
			var HEIGHT = map.getSize().y;
			var X = map.layerPointToContainerPoint(e.layerPoint).x;
			var Y = map.layerPointToContainerPoint(e.layerPoint).y;
			var mywmsParam = new URLSearchParams(mywms.wmsParams);
			var newParams = new URLSearchParams();
			newParams.set('SERVICE', 'WMS');
			newParams.set('REQUEST', 'GetFeatureInfo');
			newParams.set('QUERY_LAYERS', mywmsParam.get('layers'));
			newParams.set('LAYERS', mywmsParam.get('layers'));
			newParams.set('X', Math.round(X));
			newParams.set('Y', Math.round(Y));
			newParams.set('HEIGHT', HEIGHT);
			newParams.set('WIDTH', WIDTH);
			newParams.set('BBOX', BBOX);
			
			if(layerJsonData.service_link.includes('gte.gozdis.si')){ // exception for gte.gozdis.si
				newParams.set('INFO_FORMAT', 'application/geojson');
				newParams.set('srs(crs)', 'EPSG:3794');
				newParams.set('VERSION', '1.3.0');
			}else{
				newParams.set('SRS', 'EPSG:3912');
				newParams.set('INFO_FORMAT', 'application/json');
			}
			//newParams.set('FOMAT', 'image/png');
			newParams.set('FEATURE_COUNT', 10);
			newParams.set('TRANSPARENT', true);
			
			//var URL = layerJsonData.service_link+'?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetFeatureInfo&LAYERS='+layerJsonData.layers+'&QUERY_LAYERS='+layerJsonData.layers+'&STYLES=&BBOX='+BBOX+'&FEATURE_COUNT=5&HEIGHT='+HEIGHT+'&WIDTH='+WIDTH+'&FORMAT=image%2Fpng&INFO_FORMAT=text%2fhtml&SRS=EPSG%3A3912&X='+X+'&Y='+Y;
			var URL = decodeURI(layerJsonData.service_link+'?'+newParams.toString());
			var vsebina = '';
			$.ajax({
				dataType: "json",
				async: false,
				url: URL,
				success: function(data){
					debugOut(data.features);
					if(data.features.length) {
						Object.keys(data.features).forEach(function(keyFeat, idx, array) {
							vsebina += generatePopup(data.features[keyFeat].properties, layerJsonData.template);
							if (idx !== array.length - 1){
								vsebina += "<br>";
							}
						});
					}
				}
			}).fail(function(e) {
				console.log(e.responseText);
				console.log("Error: Did not get JSON in response from WMS server!");
				vsebina += "Napaka med pridobivanjem podatkov o tem sloju. ";
			});
			
			return vsebina;
		}
		mywms.on('load', function(){
			$('.rm'+layerJsonData.cs+'').remove();
			if(!errorLayer){
				$('.totop-layer[data-settop="'+layerJsonData.cs+'"]').css('display','block');
			}
		});
		mywms.addTo(geoserverGroup);
		
		return mywms;
	}
	
	function handleWFSlayer(layerJsonData){
		$('[data-layer="'+layerJsonData.cs+'"]').html($('[data-layer="'+layerJsonData.cs+'"]').html()+'<span class="loader rm'+layerJsonData.cs+'"></span>');
		
		var defaultParameters = {
			service : 'WFS',
			version : '1.1.0',
			request : 'GetFeature',
			typeName : layerJsonData.layers,
			outputFormat : 'json',
			SrsName : 'EPSG:3912'
		};
		var parameters = L.Util.extend(defaultParameters);
		var URL = '/proxy.php?url='+encodeURIComponent(layerJsonData.service_link + L.Util.getParamString(parameters));
		var WFSLayer = null;
		$.ajax({
			url: URL,
			method: "GET",
			async: false,
			cache: false
		}).done(function(response) {
			$('.rm'+layerJsonData.cs+'').remove();
			var randomColor = Math.floor(Math.random()*16777215).toString(16);
			$('[data-layer="'+layerJsonData.cs+'"] .indicator').css({'background-color':'#'+randomColor,'border':'1px solid #333'});
			WFSLayer = L.Proj.geoJson(response, {
				style: function () {
					return {
						"color": "#"+randomColor+"",
						"weight": 1,
						"opacity": 1
					};
				},
				onEachFeature: function (feature, layer) {
					var gFeature = feature;
					if(layerJsonData.template != null){
						layer.bindPopup(function () {
							return L.Util.template(
								layerJsonData.template.replace(/\\(.)/mg, "$1"),
								gFeature.properties
							);
						});
					}
				}
			});
			WFSLayer.on('add',function(e){
				$('.rm'+layerJsonData.cs+'').remove();
			});
			WFSLayer.addTo(geoserverGroup);
			$('.totop-layer[data-settop="'+layerJsonData.cs+'"]').css('display','block');
			/*$('[data-settop="'+layerJsonData.cs+'"]').on('click', function(e){
				$('.totop-layer').css('opacity','0.5');
				$(this).css('opacity','1');
				WFSLayer.bringToFront();
			});*/
		}).fail(function(data){
			$('.rm'+layerJsonData.cs+'').remove();
			$('.error-layer[data-settop="'+layerJsonData.cs+'"]').css('display','block');
		});
		
		return WFSLayer;
	}
	
	function handleOtherLayers(layerJsonData){
		var layers = (layerJsonData.layers != null) ? layerJsonData.layers.split(',') : [];
		L.esri.request(layerJsonData.service_link, {
			layers: layers
		}, function (error, response) {
			if (error) {
				debugOut(error);
			} else {
				$('[data-layer="'+layerJsonData.cs+'"]').html($('[data-layer="'+layerJsonData.cs+'"]').html()+'<span class="loader rm'+layerJsonData.cs+'"></span>');
				$('[data-settop="'+layerJsonData.cs+'"]').hide();
				$('.legend').html('');
				var resolutions = [];
				var origin = [];
				if(typeof response.tileInfo != 'undefined'){
					for (const [key, ext] of Object.entries(response.tileInfo.lods)) {
						resolutions.push(ext.resolution);
					}
					origin = [response.tileInfo.origin.x, response.tileInfo.origin.y];
				}
				/*var crs = new L.Proj.CRS("EPSG:3912","+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=bessel +towgs84=409.545,72.164,486.872,-3.085957,-5.46911,11.020289,17.919665 +units=m +no_defs", {
					origin: origin,
					resolutions: resolutions
				});*/
				
				var zindex = 0;
				if(response.singleFusedMapCache){
					zindex = getRandomInt(1, 50);
				} else {
					zindex = getRandomInt(50, 100);
				}
				if(typeof response.type != 'undefined' && response.type == 'Feature Layer'){
					var layerNameCombined = L.esri.featureLayer({
						url: layerJsonData.service_link,
						opacity: layerJsonData.opacity,
						layers: layers,
						useCors: false,
						zIndex: zindex,
						cacheLayers: true
					});
					debugOut('featureLayer');
					layerNameCombined.bindPopup(function (layer) {
						debugOut(layer.feature.properties);
						return template(
							layerJsonData.template.stripSlashes(),
							layer.feature.properties
						);
					});
					layerNameCombined.on('load', function(){
						$('.rm'+layerJsonData.cs+'').remove();
					});
					layerNameCombined.addTo(externalGroup);
					$('.totop-layer[data-settop="'+layerJsonData.cs+'"]').show();
					$('[data-settop="'+layerJsonData.cs+'"]').on('click', function(e){
						$('.totop-layer').css('opacity','0.5');
						$(this).css('opacity','1');
						layerNameCombined.bringToFront();
					});
				} else {
					var layers = (layerJsonData.layers != null) ? layerJsonData.layers.split(',') : [];
					var layerNameCombined = L.esri.dynamicMapLayer({
						url: layerJsonData.service_link,
						//crs: crs,
						layers: layers,
						transparent: true,
						opacity: layerJsonData.opacity,
						zIndex: zindex
					});
					debugOut('dynamicMapLayer');
					if(layerJsonData.legend == 'Y'){
						layerNameCombined.legend(function(error, legend){
							debugOut(legend);
							if(!error) {
								var html='';
								html += `<div class="card">
								<div class="card-header" id="heading${key}">
									<h2 class="mb-0">
										<button class="btn btn-link" data-toggle="collapse" data-target="#control${key}" aria-expanded="true" aria-controls="control${key}">
											${layerJsonData.layertitle}
										</button>
									</h2>
								</div>
								
								<div id="control${key}" class="collapse" aria-labelledby="heading${key}" data-parent=".accordion">
									<div class="card-body p-3">`;
										for(var i = 0, len = legend.layers.length; i < len; i++) {
											html += `<h3><strong>${legend.layers[i].layerName}</h3>`
											html += `<ul style="list-style: none; margin: 0px; padding: 0px 0px 0px 10px;">`;
											var backgroundImage = [];
											for(var j = 0, jj = legend.layers[i].legend.length; j < jj; j++){
												html += L.Util.template('<li style="padding: 5px 0px;"><img width="{width}" height="{height}" style="display: inline-block;" src="data:{contentType};base64,{imageData}"><span style="height: 20px; vertical-align: -webkit-baseline-middle; display: inline-block; margin-left: 10px;">{label}</span></li>', legend.layers[i].legend[j]);
												backgroundImage.push(L.Util.template(`url(data:{contentType};base64,{imageData})`, legend.layers[i].legend[j]));
											}
											html += `</ul>`;
											
										}
								html += `</div>
									</div>
								</div>`;
								debugOut(backgroundImage);
								if(backgroundImage.length){
									$('[data-layer="'+layerJsonData.cs+'"] .indicator').css({'background':backgroundImage.join(','),'border':'1px solid #333','background-size':'3%'});
								}
								$('.legend').html($('.legend').html() + html);
							}
						});
					}
					if(layerJsonData.template != null){
						layerNameCombined.bindPopup(function (error, layer) {
							debugOut(layer);
							if(typeof layer.features[0] !== 'undefined'){
								if(typeof layer.features[0].properties !== 'undefined'){
									debugOut(layer.features[0].properties);
									return template(
										layerJsonData.template.stripSlashes(),
										layer.features[0].properties
									);
								}
							}
						});
					}
					layerNameCombined.on('load', function(){
						$('.rm'+layerJsonData.cs+'').remove();
					});
					layerNameCombined.addTo(externalGroup);
					$('.totop-layer[data-settop="'+layerJsonData.cs+'"]').css('display','block');
					$('[data-settop="'+layerJsonData.cs+'"]').on('click', function(e){
						$('.totop-layer').css('opacity','0.5');
						$(this).css('opacity','1');
						layerNameCombined.bringToFront();
					});
				}
			}
		});
		
		return null;
	}
}

function layerManupulation(){
	map.addEventListener('click', function(event){
		let contentPopup = '';
		onClickPopupFunctions.forEach(function(item, idx, array) {
			const cs = onClickPopupFunctions[idx][2];
			const naslov = $(`a[data-layer="${cs}"]`).text();
			contentPopup += `<div class="text-center"><b>${naslov}</b></div>`
			
			const functionPopup = onClickPopupFunctions[idx][0];
			const wmsSettings = onClickPopupFunctions[idx][1];
			const popupContent = functionPopup(event, wmsSettings);
			
			if(popupContent != ''){
				contentPopup += popupContent;
			}else{
				contentPopup += "Sloj nima vsebine za prikaz.";
			}
			if (idx !== array.length - 1){
				contentPopup += "<hr>";
			}
		});
		if(contentPopup == ''){
			contentPopup = 'Ni vsebine za prikaz.';
		}
		var coord = event.latlng;
		var lat = coord.lat;
		var lng = coord.lng;
		L.popup().setLatLng(L.latLng(lat, lng)).setContent(contentPopup).openOn(map);
	});
	
	$('.totop-layer').on('click', function(e){
		$('.totop-layer').css('opacity','0.5');
		$(this).css('opacity','1');
		const settopId = this.dataset.settop;
		allLayers[settopId].bringToFront();
	});
}

function getActiveLayers(loadedFrom){
	var layersArrays = getAllSelectedCheckboxes();
	params = new URLSearchParams(layersArrays);
	if(typeof layerGroup !== 'undefined'){
		layerGroup.clearLayers();
	}
	debugOut("START GIS MAP LOADING: "+loadedFrom);
	//$('.map-loading').show();
	$.post('/util/ajaxresponse.php', {'func':'layers','layers':params.get('layers')},function(data){
		if(data.length){
			var jsonData = JSON.parse(data);
			for (const [key, value] of Object.entries(jsonData)) {
				debugOut(jsonData);
				$('[data-layer="'+jsonData[key].cs+'"]').html($('[data-layer="'+jsonData[key].cs+'"]').html()+'<span class="loader rm'+jsonData[key].cs+'"></span>');
				$('[data-settop="'+jsonData[key].cs+'"]').hide();
				var layerNameCombined2 = 'geoJson'+key;
				var exteriorStyle = {
					"color": jsonData[key].color,
					"opacity": jsonData[key].opacity
				};
				debugOut(exteriorStyle);
				if(jsonData[key].geoJSON){
					var layerNameCombined2 = new L.geoJSON(jsonData[key].geoJSON, {
						style: exteriorStyle,
						onEachFeature: function (feature, layer) {
							debugOut(feature);
							var gFeature = feature;
							if(jsonData[key].template != null){
								layer.bindPopup(function () {
									return L.Util.template(
										jsonData[key].template.replace(/\\(.)/mg, "$1"),
										gFeature.properties
									);
								});
							}
							if(feature.geometry.type == 'Point'){
								if(typeof feature.properties.marker != 'undefined'){
									var iconUrl = (feature.properties.marker.includes('http'))? feature.properties.marker : '/images/icons/'+feature.properties.marker;
									var myIcon = L.icon({
										iconUrl: iconUrl,
										iconSize: [32, 32],
										iconAnchor: [16, 16],
										popupAnchor: [16, 16],
										shadowUrl: '',
										shadowSize: [68, 95],
										shadowAnchor: [22, 94]
									});
									layer.setIcon(myIcon);
									$('[data-layer="'+jsonData[key].cs+'"] .indicator').css({'background':'#ffffff url(/images/icons/'+feature.properties.marker+') center center no-repeat', 'background-size':'contain'});
								} else {
									layer.setIcon(new L.DivIcon({
										iconSize: "auto",
										html: '<span style="width: 10px; height: 10px; background: '+jsonData[key].color+'; border-radius:50%; display: block; opacity:0.8;"></b>'
									}));
									$('[data-layer="'+jsonData[key].cs+'"] .indicator').css({'background':jsonData[key].color});
								}
							}
						}
					});
					layerNameCombined2.on('add',function(e){
						$('.rm'+jsonData[key].cs+'').remove();
					});
					layerNameCombined2.addTo(layerGroup);
					$('.totop-layer[data-settop="'+jsonData[key].cs+'"]').css('display','block');
					$('[data-settop="'+jsonData[key].cs+'"]').on('click', function(e){
						$('.totop-layer').css('opacity','0.5');
						$(this).css('opacity','1');
						layerNameCombined2.bringToFront();
					});
				} else if(jsonData[key].geoJSONURL){
					$('[data-layer="'+jsonData[key].cs+'"]').html($('[data-layer="'+jsonData[key].cs+'"]').html()+'<span class="loader rm'+jsonData[key].cs+'"></span>');
					$.get(jsonData[key].geoJSONURL, function(data){
						var json = JSON.parse(data);
						if(isJsonString(data)){
							var layerNameCombined2 =new L.geoJSON(json, {
								style: exteriorStyle,
								onEachFeature: function (feature, layer) {
									if(typeof feature.properties.marker != 'undefined'){
										var myIcon = L.icon({
											iconUrl: feature.properties.marker,
											iconSize: [32, 32],
											iconAnchor: [16, 16],
											popupAnchor: [0, -8],
											shadowUrl: '',
											shadowSize: [68, 95],
											shadowAnchor: [22, 94]
										});
										layer.setIcon(myIcon);
										debugOut(feature.properties.marker);
										$('[data-layer="'+jsonData[key].cs+'"] .indicator').css({'background':'#ffffff url('+feature.properties.marker+') center center no-repeat', 'background-size':'contain'});
									} else {
										if(feature.geometry.type == 'Point'){
											layer.setIcon(new L.DivIcon({
												iconSize: "auto",
												html: '<span style="width: 10px; height: 10px; background: '+jsonData[key].color+'; border-radius:50%; display: block; opacity:0.8;"></b>'
											}));
										}
										$('[data-layer="'+jsonData[key].cs+'"] .indicator').css({'background':jsonData[key].color});
									}
									//setLayerContent(layer, feature);
									debugOut(feature);
									var gFeature = feature;
									if(jsonData[key].template != null){
										layer.bindPopup(function () {
											return L.Util.template(
												jsonData[key].template.replace(/\\(.)/mg, "$1"),
												gFeature.properties
											);
										});
									}
									//$('.map-loading').hide();
								}
							});
							layerNameCombined2.on('add',function(e){
								$('.rm'+jsonData[key].cs+'').remove();
							});
							layerNameCombined2.addTo(layerGroup);
							$('.totop-layer[data-settop="'+jsonData[key].cs+'"]').css('display','block');
							$('[data-settop="'+jsonData[key].cs+'"]').on('click', function(e){
								$('.totop-layer').css('opacity','0.5');
								$(this).css('opacity','1');
								layerNameCombined2.bringToFront();
							});
						} else {
							bootbox.alert('Napaka pri procesiranju GeoJSON datoteke');
						}
					});
				}
			}
		} else {
			$('.map-loading').hide();
			debugOut("No Data");
		}
	});
}

function triggerMapChange(){
	var layersArrays = getAllSelectedCheckboxes();
	var baseMap = $('.maincheckbox');
	var paramsLocation = new URLSearchParams(window.location.search);
	$('.indicator').css({'background':'none','border':'none'});
	if(layersArrays.layers != ''){
		params = new URLSearchParams(layersArrays);
		if(typeof map != 'undefined'){
			params.set('zoom',map.getZoom());
			var center = map.getCenter();
			params.set('position_lat',center.lat);
			params.set('position_lng',center.lng);
			
		}
	} else {
		if(typeof map != 'undefined'){
			params.set('zoom',map.getZoom());
			var center = map.getCenter();
			params.set('position_lat',center.lat);
			params.set('position_lng',center.lng);
			params.set('layers','');
		}
	}
	if(baseMap.is(':checked')){
		params.set('baseMap','1');
		baselayers["OpenStreetMap"].addTo(map);
	} else {
		params.set('baseMap','0');
		map.removeLayer(baselayers["OpenStreetMap"]);
	}
	params.set('tools',paramsLocation.get('tools'));
	window.history.pushState('PP', 'PP', '?'+params.toString());
	getActiveLayers('triggerMapChange');
	getURLData('triggerMapChange');
}

$(function(){
	params = new URLSearchParams(window.location.search);
	if(params.has('position_lat') && params.has('position_lng')) {
		var center = L.latLng(params.get('position_lat'),params.get('position_lng'));
	} else {
		var center = L.latLng(46.151241, 14.995463);
	}
	if(params.has('zoom')) {
		var zoom = params.get('zoom');
	} else {
		var zoom = 9;
	}
	debugOut(params.get('layers'));
	if(params.get('layers') != null){
		var layersShow = params.get('layers').split(',');
		$('.nav-item').each(function(){
			var elementChilds = [];
			var currentEl = $(this);
			if(currentEl.data('childs')){
				elementChilds = currentEl.data('childs').split(',');
				layersShow.forEach(lay => {
					if(elementChilds.includes(lay) === true){
						currentEl.addClass('show');
						currentEl.children('.nav-link').addClass('open');
						currentEl.children('.dropdown-menu').addClass('show');
					}
				});
			}
		});
	}
	map = L.map('map', {
		loadingControl: true,
		zoom: 10,
		minZoom: 8,
		center: [ 45.998157144459036, 14.013766163134791 ], // [ 95363.210946, 423980.138983 ]
		maxBounds: [
			[45.3, 13.23],
			[46.9, 16.8],
		],
		maxBoundsViscosity: 1, // fully solid bounds
	}).setView(center, zoom);
	if(params.baseMap == '1'){
		debugOut(params);
		baselayers["OpenStreetMap"].addTo(map);
		$('.maincheckbox').attr('checked','checked');
	}
	//L.control.layers(baselayers, overlays).addTo(map);
	layerGroup = L.layerGroup().addTo(map);
	externalGroup = L.layerGroup().addTo(map);
	geoserverGroup = L.layerGroup().addTo(map);
	
	drawnItems = L.featureGroup().addTo(map);
	L.drawLocal = drawLang[$('html').attr('lang')];
	if(params.get('tools') == 1){
		map.addControl(new L.Control.Draw({
			edit: {
				featureGroup: drawnItems,
				poly: {
					allowIntersection: false
				}
			},
			draw: {
				polygon: {
					allowIntersection: false,
					showArea: true
				},
				marker: false,
				circlemarker: false
			}
		}));
	
		map.on(L.Draw.Event.CREATED, function (event) {
			var layer = event.layer;
			var contentObject = getPopupContent(layer);
			var content = '';
			for (const key in contentObject) {
				if (Object.hasOwnProperty.call(contentObject, key)) {
					const element = contentObject[key];
					content += langSettings[$('html').attr('lang')][key]+': '+contentObject[key]+'<br>';
				}
			}
				
			if (content !== null) {
				layer.bindPopup(content).openPopup();
			}
			$('.clipboard').val($('.clipboard').val()+JSON.stringify(layer.toGeoJSON()));
			
			layer.on('click', function(el) {
				navigator.clipboard.writeText(JSON.stringify(el.target.toGeoJSON())).then(function() {
				}, function(err) {
					bootbox.alert('Napaka pri kopiranju v odložišče.');
				});
				$('.layerData .data').html(content);
				$('.layerData').removeClass('d-none');
			});
			drawnItems.addLayer(layer);
		});
	}

	var printDownload = L.easyPrint({
		title: 'Print',
		position: 'bottomright',
		exportOnly: true,
		hideControlContainer: true,
		sizeModes: ['Current', 'A4Portrait', 'A4Landscape']
	}).addTo(map);

	$('.easyPrintSizeMode').on('click',function(e){
	});
	
	map.addControl(new L.Control.SwitchScaleControl({
		position: "bottomleft",
		dropdownDirection: "upward",
		className: "map-control-scalebar",
		updateWhenIdle: false,
		ratio: true,
		ratioPrefix: "1:",
		recalcOnPositionChange: false,
		recalcOnZoomChange: false,
		scales: [2000, 5000, 10000, 25000, 50000, 100000, 200000, 500000, 1000000, 2500000, 5000000, 10000000],
		roundScales: undefined,
		adjustScales: false
	}));
	L.control.scale({'metric':true,'imperial':false}).addTo(map);

	map.on('draw:markercontext', function (event) {
		debugOut(event);
	});

	map.on('zoom, moveend', function(e){
		var center = map.getCenter();
		var layersArrays = getAllSelectedCheckboxes();
		params = new URLSearchParams(layersArrays);
		params.set('zoom',map.getZoom());
		params.set('position_lat',center.lat);
		params.set('position_lng',center.lng);
		window.history.pushState('PP', 'PP', '?'+params.toString());
	});

	map.whenReady(function(){
		debugOut("Loaded Map");
		triggerMapChange();
		//getActiveLayers();
		//getURLData();
	});
	
	layerManupulation();
	
	dropbox = document.getElementById("dropbox");
	var fileSelect = document.getElementById("fileElem");
	dropbox.addEventListener("dragenter", dragenter, false);
	dropbox.addEventListener("dragover", dragover, false);
	dropbox.addEventListener("drop", drop, false);
	fileSelect.addEventListener("change", selectFile, false);

	$('.loadgeoJSON').on('click', function(e){
		if($('.geoJSONurl').val() != ''){
			$.get($('.geoJSONurl').val(), function(data){
				var json = JSON.parse(data);
				if(isJsonString(data)){
					new L.geoJSON(json, {
						onEachFeature: function (feature, layer) {
							setLayerContent(layer, feature)
						}
					}).addTo(map);
					$('.geoJSONurl').val('');
				} else {
					bootbox.alert('Napaka pri procesiranju GeoJSON datoteke');
				}
			});
		} else {
			bootbox.alert('Vpišite pravilen naslov GeoJSON datoteke.');
		}
	});
	L.esri.Support.cors = false;
});
window.baselayers = baselayers;
window.drawnItems = drawnItems;
window.overlays = overlays;
window.lng = lng;
window.r1 = r1;
window.r2 = r2;
window.geoLayers = geoLayers;
window.layerGroup = layerGroup;
window.externalGroup = externalGroup;
window.geoserverGroup = geoserverGroup;
window.debug = debug;
window.allLayers = allLayers;
window.onClickPopupFunctions = onClickPopupFunctions;
window.template = template;
window._round = _round;
window.strLatLng = strLatLng;
window.langSettings = langSettings;
window.drawLang = drawLang;
window.debugOut = debugOut;
window.dragenter = dragenter;
window.dragover = dragover;
window.drop = drop;
window.selectFile = selectFile;
window.getLanguageKey = getLanguageKey;
window.setLayerContent = setLayerContent;
window.generatePopup = generatePopup;
window.handleFilesSelect = handleFilesSelect;
window.handleFiles = handleFiles;
window.isJsonString = isJsonString;
window.getPopupContent = getPopupContent;
window.getRandomInt = getRandomInt;
window.crs = crs;
window.getURLData = getURLData;
window.layerManupulation = layerManupulation;
window.getActiveLayers = getActiveLayers;
window.triggerMapChange = triggerMapChange;
}.call(window, window);